import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "result_entry"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "rank_bar" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { key: 2 };
const _hoisted_8 = { key: 3 };
const _hoisted_9 = { class: "comment_box" };
const _hoisted_10 = { class: "inner" };
const _hoisted_11 = { class: "prof" };
const _hoisted_12 = { class: "ph" };
const _hoisted_13 = { class: "name" };
const _hoisted_14 = { class: "ca_1" };
const _hoisted_15 = { class: "ca_2" };
const _hoisted_16 = { class: "q_word" };
const _hoisted_17 = { class: "a_lead" };
const _hoisted_18 = { class: "comment_box box2" };
const _hoisted_19 = { class: "inner" };
const _hoisted_20 = { class: "prof" };
const _hoisted_21 = { class: "left" };
const _hoisted_22 = { class: "ca_1" };
const _hoisted_23 = { class: "ca_2" };
const _hoisted_24 = { class: "right" };
const _hoisted_25 = { class: "name" };
const _hoisted_26 = { class: "ph" };
const _hoisted_27 = { class: "w_box" };
const _hoisted_28 = {
    class: "word",
    style: { "white-space": "pre-line" }
};
const _hoisted_29 = { class: "opinion" };
const _hoisted_30 = {
    key: 0,
    class: "rank2"
};
const _hoisted_31 = { key: 0 };
const _hoisted_32 = { key: 1 };
const _hoisted_33 = { key: 2 };
const _hoisted_34 = { style: { "white-space": "pre-line" } };
const _hoisted_35 = { class: "bt_box" };
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import InertiaUtil from '@util/InertiaUtil';
import Formatter from '@util/Formatter';
import ImageFrame from '@component/ImageFrame.vue';
import { computed } from '@vue/runtime-core';
export default /*@__PURE__*/ _defineComponent({
    __name: 'result_check',
    props: {
        common: {},
        rank_data: {},
        form_data: {}
    },
    setup(__props) {
        const props = __props;
        const showRankCount = computed(() => {
            return props.rank_data.answer_count < 3 ? props.rank_data.answer_count : 3;
        });
        const form = InertiaUtil.getForm({
            results: props.form_data.results,
        });
        const onClickReturn = () => {
            window.history.back();
        };
        const onSubmit = () => {
            InertiaUtil.post(form, route('rank.store', { question_id: props.rank_data.id }));
        };
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[7] || (_cache[7] = _createElementVNode("h2", null, "満足度評価入力確認", -1)),
                            _cache[8] || (_cache[8] = _createElementVNode("p", null, [
                                _createTextVNode(" 下記の評価結果で相談を終了します。"),
                                _createElementVNode("br"),
                                _createTextVNode(" 順位に応じて、次のようにメンターへ報酬が支払われますので"),
                                _createElementVNode("br", { class: "pc" }),
                                _createTextVNode(" 入力ミスのないようにお願い致します。 ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_4, [
                                (props.rank_data.reward_amount.first_reward_amount)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                        _createVNode(ImageFrame, { src: "images/common/i_rank_1.svg" }),
                                        _createElementVNode("span", null, _toDisplayString((_b = (_a = props.rank_data.reward_amount.first_reward_amount) === null || _a === void 0 ? void 0 : _a.toLocaleString()) !== null && _b !== void 0 ? _b : 0), 1),
                                        _cache[0] || (_cache[0] = _createTextVNode("円 "))
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[3] || (_cache[3] = _createElementVNode("br", { class: "sp2" }, null, -1)),
                                (props.rank_data.reward_amount.second_reward_amount)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                        _createVNode(ImageFrame, { src: "images/common/i_rank_2.svg" }),
                                        _createElementVNode("span", null, _toDisplayString((_d = (_c = props.rank_data.reward_amount.second_reward_amount) === null || _c === void 0 ? void 0 : _c.toLocaleString()) !== null && _d !== void 0 ? _d : 0), 1),
                                        _cache[1] || (_cache[1] = _createTextVNode("円 "))
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[4] || (_cache[4] = _createElementVNode("br", { class: "sp2" }, null, -1)),
                                (props.rank_data.reward_amount.third_reward_amount)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                                        _createVNode(ImageFrame, { src: "images/common/i_rank_3.svg" }),
                                        _createElementVNode("span", null, _toDisplayString((_f = (_e = props.rank_data.reward_amount.third_reward_amount) === null || _e === void 0 ? void 0 : _e.toLocaleString()) !== null && _f !== void 0 ? _f : 0), 1),
                                        _cache[2] || (_cache[2] = _createTextVNode("円 "))
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[5] || (_cache[5] = _createElementVNode("br", { class: "sp2" }, null, -1)),
                                ((_unref(showRankCount) != 1))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, "（各１回答づつ）"))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _createVNode(ImageFrame, {
                                                src: props.rank_data.user.photo
                                            }, null, 8, ["src"])
                                        ]),
                                        _createElementVNode("div", _hoisted_13, _toDisplayString((_g = props.rank_data.user) === null || _g === void 0 ? void 0 : _g.name), 1),
                                        _createElementVNode("div", _hoisted_14, _toDisplayString((_h = props.rank_data.user.industry) === null || _h === void 0 ? void 0 : _h.name), 1),
                                        _createElementVNode("div", _hoisted_15, _toDisplayString((_j = props.rank_data.question_type) === null || _j === void 0 ? void 0 : _j.name), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(Formatter).formatCharOmit(props.rank_data.subject)), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_17, _toDisplayString(props.rank_data.answer_count) + "名の回答", 1),
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(onSubmit, ["prevent"])
                            }, [
                                _createElementVNode("div", _hoisted_18, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.rank_data.mentors, (answer, index) => {
                                        var _a, _b, _c, _d;
                                        return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _createElementVNode("div", _hoisted_22, _toDisplayString((_a = answer.user.industry) === null || _a === void 0 ? void 0 : _a.name), 1),
                                                    _createElementVNode("div", _hoisted_23, _toDisplayString((_c = (_b = answer.user.job_group) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : 'その他'), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_24, [
                                                    _createElementVNode("div", _hoisted_25, _toDisplayString((_d = answer.user) === null || _d === void 0 ? void 0 : _d.name), 1),
                                                    _createElementVNode("div", _hoisted_26, [
                                                        _createVNode(ImageFrame, {
                                                            src: answer.user.photo
                                                        }, null, 8, ["src"])
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_27, [
                                                _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(Formatter).formatCharOmit(answer.answer.content, 300)), 1),
                                                _createElementVNode("div", _hoisted_29, [
                                                    (_unref(form).results[index].rank)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                            _createVNode(ImageFrame, {
                                                                src: `images/common/i_rank_${_unref(form).results[index].rank}.svg`
                                                            }, null, 8, ["src"]),
                                                            (_unref(form).results[index].rank === 1)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "金賞"))
                                                                : _createCommentVNode("", true),
                                                            (_unref(form).results[index].rank === 2)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, "銀賞"))
                                                                : _createCommentVNode("", true),
                                                            (_unref(form).results[index].rank === 3)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "銅賞"))
                                                                : _createCommentVNode("", true)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(form).results[index].comment), 1)
                                                ])
                                            ])
                                        ]));
                                    }), 256))
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("ul", null, [
                                        _createElementVNode("li", null, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                id: "submit-button",
                                                class: "bt_back",
                                                onClick: _withModifiers(onClickReturn, ["prevent"])
                                            }, " 戻る ")
                                        ]),
                                        _cache[6] || (_cache[6] = _createElementVNode("li", null, [
                                            _createElementVNode("button", {
                                                type: "submit",
                                                id: "submit-button",
                                                class: "bt_next"
                                            }, "相談を終了する")
                                        ], -1))
                                    ])
                                ])
                            ], 32)
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
